import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Row, Column, AnchorLinks, AnchorLink, Tex, Gif, Feedback, Lightbox, Note} from 'components';
function _createMdxContent(props) {
  const _components = {
    a: "a",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(AnchorLinks, {
      children: [_jsx(AnchorLink, {
        children: "Payouts & Fees"
      }), _jsx(AnchorLink, {
        children: "Rewards & Payouts customization"
      }), _jsx(AnchorLink, {
        children: "Lightning Payouts"
      }), _jsx(AnchorLink, {
        children: "FPPS Specification"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Payouts & Fees"
    }), "\n", _jsx(_components.p, {
      children: "Braiins Pool currently applies the following fee to provide the pool mining service."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Proceeds from transaction (network) fees are shared with miners."
      }), "\n", _jsx(_components.li, {
        children: "Payouts are created daily at 9.00 UTC. Confirmation for on-chain payouts typically takes 1-2 hours, but in times of high network fees it can take longer. Lightning payouts are confirmed within couple of minutes."
      }), "\n", _jsx(_components.li, {
        children: "Payout threshold for withdrawals can be customized for each of the Financial Accounts in Payout Settings section of the account overview page."
      }), "\n"]
    }), "\n", _jsx(Row, {
      children: _jsx(Column, {
        colLg: 8,
        children: _jsxs(_components.table, {
          children: [_jsx(_components.thead, {
            children: _jsxs(_components.tr, {
              children: [_jsx(_components.th, {
                children: "Fees"
              }), _jsx(_components.th, {})]
            })
          }), _jsxs(_components.tbody, {
            children: [_jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: "Pool fee"
              }), _jsx(_components.td, {
                children: "2.5%"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: "Payout fee - Onchain (0.005 BTC and above)"
              }), _jsx(_components.td, {
                children: "free"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: "Payout fee - Onchain (under 0.005 BTC)"
              }), _jsx(_components.td, {
                children: "0.0001 BTC"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: "Payout fee - Lightning Network"
              }), _jsx(_components.td, {
                children: "free"
              })]
            })]
          })]
        })
      })
    }), "\n", _jsx(Row, {
      children: _jsx(Column, {
        colLg: 8,
        children: _jsxs(_components.table, {
          children: [_jsx(_components.thead, {
            children: _jsxs(_components.tr, {
              children: [_jsx(_components.th, {
                children: "Payout limits Onchain (Automatic & Manual)"
              }), _jsx(_components.th, {})]
            })
          }), _jsxs(_components.tbody, {
            children: [_jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: "Minimum payout"
              }), _jsx(_components.td, {
                children: "0.0002 BTC"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: "Minimum free payout"
              }), _jsx(_components.td, {
                children: "0.005 BTC"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: "Maximum payout"
              }), _jsx(_components.td, {
                children: "5 BTC"
              })]
            })]
          })]
        })
      })
    }), "\n", _jsx(Row, {
      children: _jsx(Column, {
        colLg: 8,
        children: _jsxs(_components.table, {
          children: [_jsx(_components.thead, {
            children: _jsxs(_components.tr, {
              children: [_jsx(_components.th, {
                children: "Payout limits Lightning Network"
              }), _jsx(_components.th, {})]
            })
          }), _jsxs(_components.tbody, {
            children: [_jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: "Minimum payout"
              }), _jsx(_components.td, {
                children: "0.00000001 BTC (1 satoshi)"
              })]
            }), _jsxs(_components.tr, {
              children: [_jsx(_components.td, {
                children: "Maximum payout"
              }), _jsx(_components.td, {
                children: "0.005 BTC (500,000 satoshis)"
              })]
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      children: "Rewards & Payouts customization"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "All necessary information about the Funds, Financial accounts, wallets and payout settings."
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Financial Account"
      })
    }), "\n", _jsx(_components.p, {
      children: "A Financial Account is a place where your mining rewards are stored once confirmed."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Funds"
      })
    }), "\n", _jsx(_components.p, {
      children: "The Funds tab is a part of the Braiins Pool platform where you can see and manage all of your Financial Accounts (where you receive payouts) and their available balances."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Payout Rule"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["A payout rule allows you to customize when and how you receive your coins from your Financial Account. You can choose to receive payouts at regularly scheduled time intervals (e.g. monthly, weekly, or daily), or when you reach a certain threshold of coins (e.g. receive the payout as soon as the account balance reaches 0.1 BTC). You can also select the network to be used for sending your coins. Either BTC network (onchain) or ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/Lightning_Network",
        children: "Lightning Network"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Reward Split"
      })
    }), "\n", _jsx(_components.p, {
      children: "A reward split allows you to automatically split your mining rewards between your Financial Accounts. For example, you can send 50% to your primary payout account and 25% each to two other Financial Accounts (or any other ratio you choose for as many Financial Accounts as you’d like)."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Wallet"
      })
    }), "\n", _jsx(_components.p, {
      children: "A wallet is an external destination — a bitcoin wallet address — at which you can receive your payouts from the pool."
    }), "\n", _jsx(_components.p, {
      children: "Answers for the questions and much more information below you can find in FAQ’s:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/en/braiins-pool/faqs/rewards#how-can-i-add-a-new-payout-address-wallet-to",
          children: "How can I add a new payout address (wallet) to my account?"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/en/braiins-pool/faqs/rewards#how-can-i-change-my-wallet-address-registered-payout-address",
          children: "How can I change my wallet address (registered payout address)?"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/en/braiins-pool/faqs/rewards#what-are-the-lightning-payouts-and-how-to-use-them",
          children: "What are the Lightning payouts and how to use them?"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/en/braiins-pool/faqs/rewards#are-there-any-limits-for-lightning-payouts",
          children: "Are there any limits for Lightning payouts?"
        })
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Basic settings"
      })
    }), "\n", _jsx(Lightbox, {
      src: "./images/basic-settings.png",
      alt: "Basic Settings",
      shrink: true
    }), "\n", _jsx(_components.p, {
      children: "Your mining rewards are distributed to your Financial Account(s) according to your Reward Split settings. By default, your rewards are distributed to a single Financial Account created during your sign-up. You can customize this to split the rewards among any number of Financial Accounts you desire."
    }), "\n", _jsx(_components.p, {
      children: "Each of your Financial Accounts has customizable Payout Rules. You can choose to receive payouts to your wallet at regularly scheduled time intervals, such as daily, weekly, or monthly. Alternatively, you can choose to receive payouts whenever your account balance reaches a certain threshold, such as 0.1 BTC."
    }), "\n", _jsx(_components.p, {
      children: "In all cases, our system evaluates the Payout Rules and sends the payouts once a day. Once the Payout Rules are satisfied, your payment will be triggered."
    }), "\n", _jsx(_components.p, {
      children: "Alternatively, if the balance of your Financial Account exceeds the minimum payout limit, you may also request an Immediate Payout."
    }), "\n", _jsxs(_components.p, {
      children: ["To explore advanced setup options view ", _jsx(_components.a, {
        href: "https://academy.braiins.com/en/braiins-pool/faqs/rewards/",
        children: "FAQ’s > Rewards"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "Lightning Payouts"
    }), "\n", _jsx(_components.h3, {
      children: "Basics"
    }), "\n", _jsx(_components.p, {
      children: "Lightning network is a 2nd layer network built upon Bitcoin blockchain with the aim to transfer Bitcoin transactions instantly for nearly zero cost and at a scale. Such transactions use peer-to-peer channels for transfer between point A and point B. For a lightning payout to work the sending and receiving party needs to have a route between them. Braiins Pool runs its own Lighning node which has open channels to the most frequent wallet operators or routing nodes. To accept such a payment users need to use a wallet of their choice or to run their own Lightning Node with channel(s) connected to Lightning network."
    }), "\n", _jsx(_components.h3, {
      children: "Payment Options"
    }), "\n", _jsx(_components.p, {
      children: "There are two types of Lightning payouts available at Braiins Pool:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Regular payouts"
        }), " - wallet with support of Lightning Address needs to be used. Lightning address has the same format as an email address. It gets translated into the URL, which returns a lightning invoice in the background. This usually works well with custodial wallets. Self-custodial (a.k.a. non-custodial) wallets can run into troubles (read below). Regular payouts are triggered daily at 9.00 UTC."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Manual withdrawals"
        }), " - this is the very basic lightning payment request where your wallet generates an invoice for a predefined amount of sats and you paste this invoice into our web. You can request manual withdrawal 1x per 24 hours. It gets processed within 60 minutes (usually 5 minutes after each hour)."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "We don’t support LNURL withdrawals."
    }), "\n", _jsx(_components.h3, {
      children: "Wallet Compatibility"
    }), "\n", _jsx(_components.p, {
      children: "Every transaction via lightning network requires the receiving node to be online in order to reach your wallet. This is pretty easy with custodial wallets. The node is not yours, but it’s run by a custodian. Typically by the wallet operator. Such nodes are almost always online and lightning transaction works like a charm. You don’t have to create any channels, but you have to trust the custodian as the sats are not under your control."
    }), "\n", _jsx(_components.p, {
      children: "With self-custodial wallets you control the node. You can run them on a dedicated computer or on your mobile phone. Whenever your node goes offline, you are not able to accept transactions (this happens quite a lot on mobile phones). There’s also an initial cost you have to pay in order to have a channel created to send or receive sats (as the channel creation is an on-chain transaction). Therefore self-custodial wallets are more useful for people using lightning on day-to-day basis."
    }), "\n", _jsxs(_components.p, {
      children: ["Not all the wallets support lightning addresses but all the wallets support invoices. You can check wallet support of lightning addresses ", _jsx(_components.a, {
        href: "https://github.com/andrerfneves/lightning-address/blob/master/README.md",
        children: "here"
      }), ". Since the lightning address requires the destination node to provide the invoice just in time when the transaction is created, some self-custodial wallets use pregenerated HODL invoices (your node pregenerates number of blank invoices and shares them with the wallet provider). Once the invoice exists (directly or through lightning address) and is used for a lightning transaction, it tries to reach the destination node (yours or your custodian)."]
    }), "\n", _jsxs(_components.p, {
      children: ["Every invoice has an expiration period. If the destination node does not come online before the period ends, the invoice expires. Braiins returns all the funds to your balance in such a case and mark payout as failed. You should make sure that invoice generated by your self-custodial wallet has expiration period long enough so you can claim it (custodial wallets accept the payout right away). Recommended expiration time is 24 hours, minimum is 1-2 hours (we generate manual withdrawals every hour + some extra time for you to claim it in case of self-custodial wallets, for the daily automatic payout the time starts ticking at the time we generate it). You can use ", _jsx(_components.a, {
        href: "https://lightningdecoder.com/",
        children: "a lightning decoder"
      }), " to check expiration of any invoice."]
    }), "\n", _jsx(_components.h2, {
      children: "FPPS Specification"
    }), "\n", _jsx(_components.p, {
      children: "The Full Pay Per Share (FPPS) model follows the rule that every unit of work (share) delivered to the pool is guaranteed a mining reward."
    }), "\n", _jsx(_components.p, {
      children: "This reward is calculated daily once the day is over. It is based on all the blocks mined by the whole network for the given day (UTC time), but recalculated as if the average 144 blocks had been mined. That means the miners receive steady rewards regardless how many blocks are found during a day."
    }), "\n", _jsx(_components.p, {
      children: "This reward consists of two parts:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx("strong", {
          children: "Coinbase reward cut"
        }), " - mining reward defined by Bitcoin network and stable between halvings proportional\nto submitted shares for a given difficulty."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx("strong", {
          children: "Transaction fees cut"
        }), " - average block fees determined by usage of the network and demand for block space\nproportional to submitted shares for a given difficulty."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "The final reward payable to the miner is the reward calculated according to the rules below, from which the amount equal to the pool fee (a percentage of the calculated reward) is subtracted."
    }), "\n", _jsx(_components.h3, {
      children: "Coinbase reward cut calculation"
    }), "\n", _jsxs(_components.p, {
      children: ["Final coinbase reward cut ", _jsx(Tex, {
        math: "(CRC)"
      }), " awarded to the miner depends on the number of accepted shares ", _jsx(Tex, {
        math: "(S)"
      }), " the miner delivered to the pool, difficulty of the network ", _jsx(Tex, {
        math: "/"
      }), " and coinbase block reward ", _jsx(Tex, {
        math: "(C)"
      }), ":"]
    }), "\n", _jsx(Tex, {
      block: true,
      math: "CRC = C \\times \\frac{S}{D}"
    }), "\n", _jsx(_components.h4, {
      children: "Example 1"
    }), "\n", _jsxs(_components.p, {
      children: ["Miner with 1 TH/s produces approximately 20,116,568 shares a day ", _jsx(Tex, {
        math: "(S)"
      }), ". Difficulty ", _jsx(Tex, {
        math: "(D)"
      }), " on 30", _jsx("sup", {
        children: "th"
      }), " November 2023 was 67 957 790 298 897. The current coinbase block reward is 6.25 BTC ", _jsx(Tex, {
        math: "(C)"
      }), ". Coinbase reward cut for 1 TH/s is 0.00000185 BTC (185 sats)."]
    }), "\n", _jsxs(_components.p, {
      children: ["It gets more complex when there is a difficulty and/or halving on the corresponding day of the calculation. In such a case the day is split into 2 (or 3, in the case that both happen on the same day) time slots where difficulty and ", _jsx(Tex, {
        math: "(CRC)"
      }), " is calculated for all of them."]
    }), "\n", _jsx(_components.h4, {
      children: "Example 2"
    }), "\n", _jsxs(_components.p, {
      children: ["There is a difficulty change at 6 a.m. ", _jsx(Tex, {
        math: "(S)"
      }), " from the previous example is split to ", _jsx(Tex, {
        math: "(S1)"
      }), " = 5,029,142 and ", _jsx(Tex, {
        math: "(S_2)"
      }), " = 15,087,426. Old difficulty ", _jsx(Tex, {
        math: "(D_1)"
      }), " = 64,678,587,803,496, new difficulty ", _jsx(Tex, {
        math: "(D_2)"
      }), " = 67 957 790 298 897. ", _jsx(Tex, {
        math: "(C)"
      }), " is the same for both time slots. ", _jsx(Tex, {
        math: "(CRC) = (CRC_1) + (CRC_2)"
      }), " = 0.00000049 + 0.00000139 = 0.00000187 (187 sats)."]
    }), "\n", _jsx(_components.h4, {
      children: "Example 3"
    }), "\n", _jsxs(_components.p, {
      children: ["There is a halving at 6 a.m. ", _jsx(Tex, {
        math: "(S_1)"
      }), " = 5,029,142 and ", _jsx(Tex, {
        math: "(S_2)"
      }), " = 15,087,426. There is only one difficulty ", _jsx(Tex, {
        math: "(D)"
      }), " = 67,957,790,298,897. ", _jsx(Tex, {
        math: "(C_1)"
      }), " = 6.25 BTC and ", _jsx(Tex, {
        math: "(C_2)"
      }), " = 3.125 BTC. ", _jsx(Tex, {
        math: "(CRC) = (CRC_1) + (CRC_2)"
      }), " = 0.00000049 + 0.00000069 = 0.00000116 (116 sats)."]
    }), "\n", _jsx(_components.h3, {
      children: "Transaction fees cut calculation"
    }), "\n", _jsxs(_components.p, {
      children: ["We calculate the trimmed average mining fee from the blocks and award them proportionally to the miner as transaction fees cut ", _jsx(Tex, {
        math: "(TFC)"
      }), ":"]
    }), "\n", _jsx(Tex, {
      block: true,
      math: "TFC = AF \\times \\frac{S}{D}"
    }), "\n", _jsx(_components.p, {
      children: "where:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(Tex, {
          math: "(TFC)"
        }), " Transaction fees cut"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(Tex, {
          math: "(AF)"
        }), " Average mining fee"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(Tex, {
          math: "(S)"
        }), " shares delivered to a pool for a given day"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(Tex, {
          math: "(D)"
        }), " difficulty of the network"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Again the day is split into 2 periods if a difficulty changes during the day. The halving does not affect the calculation of average mining proceeds."
    }), "\n", _jsx(_components.h4, {
      children: "Example 4"
    }), "\n", _jsxs(_components.p, {
      children: ["Average mining fee ", _jsx(Tex, {
        math: "(AF)"
      }), " for 30", _jsx("sup", {
        children: "th"
      }), " November 2023 = 0.49862314. Using the number of shares from Example 1 the ", _jsx(Tex, {
        math: "(TFC)"
      }), " = 0.00000015 BTC (15 sats). FPPS reward Total FPPS reward ", _jsx(Tex, {
        math: "(TR)"
      }), " combines both parts calculated previously, thus:"]
    }), "\n", _jsx(Tex, {
      block: true,
      math: "TR = \\sum_{i=1}^{n} CRC_i + \\sum_{j=1}^{m} TFC_j"
    }), "\n", _jsx(_components.p, {
      children: "where:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(Tex, {
          math: "(CRC_i)"
        }), " coinbase reward cuts for all difficulty and/or halving time slots during the day (most of the\nday it’s only one period)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(Tex, {
          math: "(TFC_j)"
        }), " transaction fees cuts for all difficulty time slots during the day (most of the day it’s only\none period)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(Tex, {
          math: "n"
        }), " number of difficulty and halving time slots during the day (1,2 or 3)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(Tex, {
          math: "m"
        }), " number of difficulty time slots during the day (1 or 2)"]
      }), "\n"]
    }), "\n", _jsx(_components.h4, {
      children: "Example 5"
    }), "\n", _jsxs(_components.p, {
      children: ["Total FPPS reward for 1 TH/s for 30", _jsx("sup", {
        children: "th"
      }), " November 2023 therefore combines examples 1 and 4 giving ", _jsx(Tex, {
        math: "(TR) = (CRC) + (TFC)"
      }), " = 0.00000185 + 0.00000015 = 0.00000200 BTC. This FPPS reward is a gross reward. The pool fee is deducted giving a net profitability of 0.00000195 BTC per 1 TH/s in case of a 2.5% fee."]
    }), "\n", _jsx(Feedback, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
